import FormInput from 'components/FormInput';

const ContactStep = () => (
  <>
    {/* E-mail */}
    <FormInput label='E-mail *' id='email' placeholder='voorbeeld@gmail.nl' />

    {/* Mobile phone */}
    <div className='same-line'>
      <FormInput
        label='Land *'
        id='countryCode'
        placeholder='+31'
        customClass='short-input'
      />
      <FormInput
        label='Telefoonnummer *'
        id='mobilePhone'
        placeholder='0612345678'
        customClass='long-input'
      />
    </div>
  </>
);

export default ContactStep;
